module.exports = __webpack_public_path__ + "b28098689a1b5928b188390562db8cc9.pdf";